export enum PlayerRoleEnum {
  CHIEF = 'CHIEF',
  TITULAR = 'TITULAR',
  REPLAC = 'REPLAC',
}
